import { createFileRoute, notFound } from "@tanstack/react-router";
import giftStyles from "../styles/gifts.css?url";
import { GiftShop } from "../components/membership/gift-pages";
import { creatorPageHead, shellFrom, withStylesheet } from "../lib/head";
import { keepSearch, searchText } from "../lib/search";
import { loadGiftShop } from "../server/gifts";

/** Giving a membership (/join/gift): a tier, a length and a note, paid once. Private. */
export const Route = createFileRoute("/join/gift/")({
  validateSearch: keepSearch,
  loader: async () => {
    const data = await loadGiftShop();
    if (data.kind === "missing") throw notFound();
    return data;
  },
  head: ({ matches, loaderData }) => {
    const shell = shellFrom(matches);
    if (!shell || !loaderData) return {};
    return withStylesheet(
      creatorPageHead(shell, {
        pathname: "/join/gift",
        title: `Give a membership | ${loaderData.creatorName}`,
        description: `Give someone a membership to ${loaderData.creatorName}.`,
        noindex: true,
      }),
      giftStyles,
    );
  },
  component: GiveMembership,
});

function GiveMembership() {
  const data = Route.useLoaderData();
  const search = Route.useSearch();
  return (
    <GiftShop
      creatorName={data.creatorName}
      available={data.available}
      plans={data.plans}
      signedIn={data.signedIn}
      from={data.from}
      planId={searchText(search, "plan") ?? ""}
      months={Number(searchText(search, "months")) || 1}
    />
  );
}
